import { createAction } from "redux-actions";
import {
  SET_CHANGE_DECISION_DETAILS,
  TOGGLE_MODAL_MQ_CHANGE_DECISION,
} from "../types/changeDecisionModalReducerTypes";

export const toggleMQDecisionModal = createAction(
  TOGGLE_MODAL_MQ_CHANGE_DECISION
);

export const setChangeDecisionDetails = createAction(
  SET_CHANGE_DECISION_DETAILS
);



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/actions/changeDecisionModalsActions.js